import Cookies from 'universal-cookie';

export const loadUserCookie = () => {
  return (dispatch, getState) => {
    const cookies = new Cookies();
    const tokenCookie = cookies.get('token')

    if (typeof tokenCookie === 'undefined') {
      dispatch({type: "AUTHENTICATION_ERROR"});
    } else {
      const headers = { "Content-Type": "application/json",};
      headers["Authorization"] = `Token ${tokenCookie}`;
      return fetch("/api/auth/refresh-token",
        {
          headers,
          method: "POST",
        })
        .then(res => {
          if (res.status === 200) {
              res.json().then(data => {
                cookies.set('name', data.token, { path: '/' });
                dispatch({type: 'LOGIN_SUCCESSFUL', data: data })
                dispatch({type: 'GET_CART', data: data });
              })
              return res;
          } else if (res.status === 400 || res.status === 401) {
            dispatch({type: "AUTHENTICATION_ERROR"});
            }
          }
        )
    }
  }
}

export const loadUser = () => {
  return (dispatch, getState) => {
    console.log("Load user")
    dispatch({type: "USER_LOADING"});

    let token = getState().auth.token;
    if (token === null) {
      dispatch({type: "AUTHENTICATION_ERROR"});
    } else {
      console.log("Getting user")
      const headers = { "Content-Type": "application/json",};
      headers["Authorization"] = `Token ${token}`;
      return fetch("/api/auth/refresh-token",
        {
          headers,
          method: "POST",
        })
        .then(res => {
          if (res.status === 200) {
              res.json().then(data => {
                dispatch({type: 'LOGIN_SUCCESSFUL', data: data })
                dispatch({type: 'GET_CART', data: data });
              })
              return res;
          } else if (res.status === 400 || res.status === 401) {
            dispatch({type: "AUTHENTICATION_ERROR"});
            }
          }
        )
    }
  }
}


export const codeLogin = (email, recovercode) => {
  return (dispatch, getState) => {
    let headers = { "Content-Type": "application/json",};
    let body = JSON.stringify({email, recovercode});
    console.log(body)
    return fetch("/api/auth/reset-password/code",
      {
        headers,
        body,
        method: "POST",
      })
      .then(res => {
        if (res.status === 200) {
            res.json().then(data => {
              const cookies = new Cookies();
              cookies.set('token', data.token, { path: '/' });
              dispatch({type: 'LOGIN_SUCCESSFUL', data: data })
              dispatch({type: 'GET_CART', data: data });
            })
            return res;
        } else if (res.status === 400) {
            console.log("Status 400")
            throw res;
        } else {
          throw res;
        }
      })
  }
}


export const login = (username, password) => {
  return (dispatch, getState) => {
    let headers = { "Content-Type": "application/json",};
    let body = JSON.stringify({username, password});
    return fetch("/api/auth/get-token",
      {
        headers,
        body,
        method: "POST",
      })
      .then(res => {
        if (res.status < 500) {
          return res.json().then(data => {
            return {status: res.status, data};
          })
        } else {
          console.log("Server Error!");
          throw res;
        }
      })
      .then(res => {
        if (res.status === 200) {
            const cookies = new Cookies();
            cookies.set('token', res.data.token, { path: '/' });
            dispatch({type: 'LOGIN_SUCCESSFUL', data: res.data });
            dispatch({type: 'GET_CART', data: res.data });
            return res.data;
        } else if (res.status === 403 || res.status === 401) {
            dispatch({type: "AUTHENTICATION_ERROR", data: res.data});
            throw res.data;
        } else {
            dispatch({type: "LOGIN_FAILED", data: res.data});
            throw res.data;
        }
      })
      .catch(res => {
        throw res.data;
      })
  }
}

export const createUser = ( email, telephone ) => {
  return (dispatch, getState) => {
    let headers = { "Content-Type": "application/json",};
    let cart = getState().cart
    let body = JSON.stringify({
      email, 
      telephone,
      cart
    });
    return fetch("/api/users/create",
      {
        headers,
        body,
        method: "POST",
      })
      .then(res => {
        if (res.status === 200) {
          return res.json().then(data => {
            const cookies = new Cookies();
            cookies.set('token', data.token, { path: '/' });
            dispatch({type: 'LOGIN_SUCCESSFUL', data: data });
            dispatch({type: 'GET_CART', data: data });
            return data
          })
        } else if (res.status === 401) {
          return res.status
        } else {
          return res.status
        }
      })
  }
}

export const logout = () => {
  return (dispatch, getState) => {
    let headers = {"Content-Type": "application/json"};
    const token = getState().auth.token;
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }

    return fetch("/api/auth/logout", {headers, method: "POST"})
      .then(res => {
        if (res.status === 204) {
          const cookies = new Cookies();
          cookies.remove('token', { path: '/' });
          dispatch({type: 'LOGOUT_SUCCESSFUL'});
          dispatch({type: "CLEAR_CART"});
          return res.data;
        } else if (res.status === 403 || res.status === 401) {
          dispatch({type: "AUTHENTICATION_ERROR", data: res.data});
          dispatch({type: "CLEAR_CART"});
          throw res.data;
        }
      })
  }
}

export const deleteUser = () => {
  return (dispatch, getState) => {
    let headers = {"Content-Type": "application/json"};
    const token = getState().auth.token;
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }

    return fetch("/api/user/archive", {headers, method: "POST"})
      .then(res => {
        if (res.status === 200) {
          const cookies = new Cookies();
          cookies.remove('token', { path: '/' });
          dispatch({type: 'LOGOUT_SUCCESSFUL'});
          dispatch({type: "CLEAR_CART"});
          return res.data;
        }
      })
  }
}


export const removeToken = () => {
  return (dispatch, getState) => {
    const cookies = new Cookies();
    cookies.remove('token', { path: '/' });
    dispatch({type: 'LOGOUT_SUCCESSFUL'});
  }
}


export const register = (email, password) => {
  return (dispatch, getState) => {
    let headers = { "Content-Type": "application/json",};
    let body = JSON.stringify({email, password});
    return fetch("/api/auth/register",
      {
        headers,
        body,
        method: "POST",
      })
      .then(res => {
        if (res.status < 500) {
          return res.json().then(data => {
            return {status: res.status, data};
          })
        } else {
          console.log("Server Error!");
          throw res;
        }
      })
      .then(res => {
        if (res.status === 200) {
            dispatch({type: 'LOGIN_SUCCESSFUL', data: res.data });
            console.log("Login Success");
            return res.data;
        } else if (res.status === 403 || res.status === 401) {
            dispatch({type: "AUTHENTICATION_ERROR", data: res.data});
            console.log("AUTHENTICATION_ERROR");
            throw res.data;
        } else {
            dispatch({type: "LOGIN_FAILED", data: res.data});
            console.log("Login Failed");
            throw res.data;
        }
      })
  }
}

export const newPassword = (newpassword, recovercode) => {
  return (dispatch, getState) => {
    let headers = { "Content-Type": "application/json",};
    let body = JSON.stringify({newpassword, recovercode});
    const token = getState().auth.token;
    headers["Authorization"] = `Token ${token}`;
    return fetch("/api/auth/new-password", {headers, body, method: "POST",})
      .then(res => {
        if (res.status === 200) {
          return res
        } else {
          console.log("Error")
          throw res
      }
    })
  }
}


export const firstPassword = (password) => {
  return (dispatch, getState) => {
    let headers = { "Content-Type": "application/json",};
    let body = JSON.stringify({password});
    const token = getState().auth.token;
    headers["Authorization"] = `Token ${token}`;
    return fetch("/api/auth/first-password", {headers, body, method: "POST",})
      .then(res => {
        if (res.status === 200) {
          dispatch({type: "PASSWORD_SET"});
          return res
        } else {
          console.log("Error")
          throw res
      }
    })
  }
}


export const landingCreateUser = (email, premiumSelected) => {
  return (dispatch, getState) => {
    let headers = { "Content-Type": "application/json",};
    let body = JSON.stringify({email, premiumSelected});
    return fetch("/api/landing/signup",
      {
        headers,
        body,
        method: "POST",
      })
      .then(res => {
        if (res.status === 200) {
          res.json().then(data => {
            const cookies = new Cookies();
            cookies.set('token', data.token, { path: '/' });
            dispatch({type: 'LOGIN_SUCCESSFUL', data: data });
          })
          return res.status
        } else if (res.status === 401) {
          return res.status
        } else {
          return res.status
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/auth.js